import { groupKey } from "./aiGroups";

const RE = /^(.*?)(\d+)\s*$/;
const ctr = (it, i) => { const b = it.f.name?.box; return b ? (b[i] + b[i + 2]) / 2 : 0; };

// Positions of one sequence standing in the wrong order (P1, P2, P4, P3, P5) -> proposal to sort them; rows keep all their data.
export function findOrderIssue(items, skipIds) {
    const seqs = new Map();
    items.forEach((it) => {
        if (it.include === false || it.f.name?.fb === "removed") return;
        const m = String(it.f.name?.value ?? "").trim().match(RE);
        if (!m) return;
        const k = `${groupKey(it)}|${m[1].trim().toLowerCase()}`;
        if (!seqs.has(k)) seqs.set(k, []);
        seqs.get(k).push({ it, num: Number(m[2]) });
    });
    for (const [key, list] of seqs) {
        if (list.some((x) => skipIds?.has(x.it._id))) continue;
        if (list.every((x, i) => i === 0 || list[i - 1].num <= x.num)) continue;
        const sorted = [...list].sort((a, b) => a.num - b.num);
        const wrong = list.filter((x, i) => x !== sorted[i]).map((x) => String(x.it.f.name.value));
        return { key, slots: list.map((x) => x.it._id), ids: sorted.map((x) => x.it._id), wrong, sig: `order:${key}:${list.map((x) => x.it._id).join(",")}` };
    }
    return null;
}

// Duplicate numbers inside one position sequence (e.g. B P4, B P4, B P5) -> proposal to renumber consecutively.
export function findNumberingIssue(items) {
    const seqs = new Map();
    items.forEach((it) => {
        if (it.include === false || it.f.name?.fb === "removed") return;
        const m = String(it.f.name?.value ?? "").trim().match(RE);
        if (!m) return;
        const k = `${groupKey(it)}|${m[1].trim().toLowerCase()}`;
        if (!seqs.has(k)) seqs.set(k, []);
        seqs.get(k).push({ it, prefix: m[1], num: Number(m[2]) });
    });
    for (const [key, list] of seqs) {
        const nums = list.map((x) => x.num);
        if (!nums.some((n, i) => nums.indexOf(n) !== i)) continue;
        const order = [...list].sort((a, b) => a.num - b.num || a.it.page - b.it.page || ctr(a.it, 1) - ctr(b.it, 1) || ctr(a.it, 0) - ctr(b.it, 0));
        const start = Math.min(...nums);
        const changes = order.map((x, i) => ({ id: x.it._id, from: String(x.it.f.name.value), to: `${x.prefix}${start + i}` })).filter((c) => c.from.trim() !== c.to);
        if (changes.length) return { key, changes, sig: `${key}:${changes.map((c) => `${c.id}=${c.to}`).join(",")}` };
    }
    return null;
}
